module.exports = __webpack_public_path__ + "img/product5.f7c9493b.png";